module.exports = __webpack_public_path__ + "static/media/icon-marker.1ab4be8a.svg";